import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Modal from "react-modal";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import {
  add_blog_category,
  update_blog_category,
} from "../../../data/ApiEndpoints";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { fetchParentBlogCategoriesData } from "../../../redux/ad-blog-reducers/blogSlice";
import SelectDropdownLabel from "../../components-react/SelectDropdownLabel";
import ParentCategoryForm from "./ParentCategoryForm";

function validateBlogCategoriesForm(formValues) {
  let errors = {};

  if (!formValues.selectedParentCategory) {
    errors.selectedParentCategory = "blog parent category required!";
  }

  if (!formValues.categoryName) {
    errors.categoryName = "blog category name required!";
  } else if (formValues.categoryName.length > 100) {
    errors.categoryName =
      "Blog category name cannot be greater than 100 characters!";
  } else if (/[^a-zA-Z0-9 ]/.test(formValues.categoryName)) {
    errors.categoryName =
      "Blog category name must not contain special characters!";
  }

  return errors;
}

const CategoriesForm = ({
  userInfoData,
  closeModal,
  callFunction,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const { parentBlogCategories, parentBlogCategoriesLoading } = useSelector(
    (state) => state.blog
  );

  const [allBlogCategories, setAllBlogCategories] = useState([]);
  const iniFormvalues = {
    selectedParentCategory:
      isEdit && rowData?.parent_category && rowData?.parent_category_name
        ? {
            label: rowData.parent_category,
            value: rowData.parent_category_name,
          }
        : "",
    categoryName: isEdit && rowData?.name ? rowData.name : "",
    isActive: isEdit && rowData?.status ? true : false,
  };
  const [formValues, setFormValues] = useState(iniFormvalues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onChangeInput = (e) => {
    setIsSubmit(false);

    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (name, value) => {
    setIsSubmit(false);

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSubmit = () => {
    setFormErrors(validateBlogCategoriesForm(formValues));
    setIsSubmit(true);
  };

  function getBlogCategories() {
    const filters = {
      page: 1,
      limit: 1000,
      status: 1,
    };

    dispatch(
      fetchParentBlogCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleAdd = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_blog_category : add_blog_category;
    const token = userInfoData?.token;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    getBlogCategories();
  }, []);

  useEffect(() => {
    if (
      parentBlogCategories?.status &&
      parentBlogCategories?.data?.length > 0
    ) {
      const allBlogs = parentBlogCategories.data?.map((blog) => {
        return { label: blog?.name, value: blog?.uid, info: blog };
      });

      setAllBlogCategories(allBlogs);
    } else {
      setAllBlogCategories([]);
    }
  }, [parentBlogCategories]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        parent_category: formValues.selectedParentCategory?.value || "",
        name: formValues.categoryName || "",
        value:
          formValues.categoryName?.replace(/\s+/g, "_")?.toLowerCase() || "",
        status: formValues.isActive ? 1 : 0,
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `${isEdit ? "Update" : "Add"} Blog Category`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={() => setModValues(iniModvalues)}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        <ParentCategoryForm
          userInfoData={userInfoData}
          closeModal={() => setModValues(iniModvalues)}
          callFunction={() => getBlogCategories()}
        />
      </Modal>

      <CommonHeadingNBtns
        title="Manage Blog sub Categories"
        btnTxt={isEdit ? "Update" : "Submit"}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox span2">
            <label
              htmlFor="selectedParentCategory"
              className={`formInputLabel ${
                formErrors?.selectedParentCategory && "formError"
              }`}
            >
              blog parent category <span className="required">*</span>
            </label>

            <div className="input-add-btn flexBetween">
              <div
                className={`commonWrapper ${
                  formErrors.selectedParentCategory ? "formError" : ""
                }`}
              >
                <SelectDropdownLabel
                  options={allBlogCategories}
                  selectedOption={formValues.selectedParentCategory}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("selectedParentCategory", selectedValue)
                  }
                  name="Parent Category"
                  isDisable={parentBlogCategoriesLoading}
                />
              </div>

              <button
                type="button"
                className="btn btn-dark extraBtn"
                style={{
                  minWidth: "150px",
                  height: "60px",
                  textTransform: "capitalize",
                }}
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "add",
                  }))
                }
              >
                Add New
              </button>
            </div>
          </div>

          <div className="formInputBox span2">
            <label htmlFor="categoryName" className={`formInputLabel `}>
              blog sub category Name
              <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Blog Category Name"
              className={`formInput ${
                formErrors?.categoryName ? "formError" : ""
              }`}
              name="categoryName"
              value={formValues.categoryName}
              onChange={onChangeInput}
            />

            {formErrors?.categoryName && (
              <span className="error-label">
                {formErrors.categoryName || ""}
              </span>
            )}
          </div>
        </div>

        <div className="formInputsGrid switchInputs">
          <div className="formInputBox formInputSwitchBox">
            <div
              className={`commonWrapper commonSwitchWrapper no-border ${
                formErrors?.isActive ? "formError" : ""
              }`}
            >
              <Form.Check
                type="switch"
                name="isActive"
                label={`${formValues.isActive ? "Active" : "Not Active"}`}
                checked={formValues.isActive}
                onChange={onChangeInput}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CategoriesForm;
